import React from 'react'
import { useIntl } from 'react-intl'

// hooks
import useMessages from '../../hooks/useMessages'

// components
import ErrorScreen from '../ErrorScreen/ErrorScreen'

// styles
import * as SC from './PageErrorViewStyles'

// types
import { AvailableLanguages } from '../../types/types'

// utils
import { ERROR_PAGE_CODE } from '../../utils/enums'
import Paths from '../../routes/paths'

type Props = {
	statusCode: ERROR_PAGE_CODE
	onRetry?: () => void
	isRetrying?: boolean
	minHeight?: string
}

const PageErrorView = ({ statusCode, onRetry, isRetrying, minHeight = '60vh' }: Props) => {
	const { messages } = useMessages()
	const { locale } = useIntl() as { locale: AvailableLanguages }

	const homePath = Paths[locale]?.['/salons'] ?? '/salons/'
	const homeButton = { label: messages['Go to salons'], href: homePath }

	switch (statusCode) {
		case ERROR_PAGE_CODE.NOT_FOUND:
			return (
				<ErrorScreen
					title={
						<SC.NotFoundTitle>
							<SC.NotFoundCode>{statusCode}</SC.NotFoundCode>
							<SC.NotFoundMessage>{messages['Page not found.']}</SC.NotFoundMessage>
						</SC.NotFoundTitle>
					}
					button={homeButton}
					minHeight={minHeight}
				/>
			)
		case ERROR_PAGE_CODE.UNAUTHORIZED:
			return <ErrorScreen title={messages['Unauthorized. You must be logged in to perform this action.']} button={homeButton} minHeight={minHeight} />
		case ERROR_PAGE_CODE.FORBIDDEN:
			return <ErrorScreen title={messages['Access denied. You do not have permission to view this page.']} button={homeButton} minHeight={minHeight} />
		default:
			return (
				<ErrorScreen button={onRetry ? { label: messages['Try again'], onClick: onRetry, isLoading: isRetrying } : undefined} minHeight={minHeight} />
			)
	}
}

export default PageErrorView
